<div class="tw-bg-white tw-font-lexend tw-rounded-t-[25px] tw-relative">

  <!-- handle + close -->
  <div
    type="button"
    class="tw-absolute tw-right-[24px] tw-top-[17px] tw-h-6 tw-aspect-square"
    (click)="close()"
    aria-label="Close"
  >
    <img src="/assets/icons/close-gray-rounded-edges.png" class="tw-h-6 tw-aspect-square" alt="Close" />
  </div>
  <!-- secure strip -->
  <div class="tw-bg-gradient-address-prefill tw-rounded-t-[25px] tw-rounded-b-2.5 tw-p-4 tw-pb-3 tw-border tw-border-yellow-25">
    <div class="tw-flex tw-items-center tw-justify-center tw-w-full tw-flex-col">
<!--     lock icon-->
      <div class="">
          <img src="/assets/icons/dark-yellow-lock.png" class="tw-h-5 tw-aspect-square" alt="Powered By Shiprocket" />
      </div>
      <div>
        <div class="tw-text-50 tw-font-[700] tw-text-black" i18n="@@verifyNumberSecurely">Verify Number Securely</div>
        <div class="tw-w-16 tw-mx-auto tw-flex tw-flex-col tw-gap-[7px]">
          <div class="tw-h-[2px] tw-rounded-full tw-bg-teal-400"></div>
          <div class="tw-h-[2px] tw-rounded-full tw-flex tw-justify-between tw-w-full tw-gap-2">
            <div class="tw-h-[2px] tw-w-[35.94%] tw-rounded-full tw-bg-teal-400"></div>
            <div class="tw-h-[2px] tw-rounded-full tw-bg-gray-200 tw-w-full"></div>
          </div>
          <div class="tw-h-[2px] tw-rounded-full tw-bg-gray-200">
            <div class="tw-h-[2px] tw-w-[68.75%] tw-rounded-full tw-bg-teal-400 tw-ml-auto"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- content -->
  <div class="tw-p-6 tw-pb-9">
    <!-- State 1: mobile -->
    <ng-container *ngIf="resolvedMode === 'mobile'">
      <div class="tw-text-600 tw-leading-tight tw-text-black tw-mb-[14px]" i18n="@@enterMobileNumberToFillAddress">
        <span>Enter your mobile number</span>
        <br />
        <span class="tw-font-[700]">to fill address</span>
      </div>

      <div class="tw-border tw-border-gray-300 tw-rounded-3 tw-h-12 tw-flex tw-items-center tw-overflow-hidden tw-bg-gray-100 tw-p-[15.4px]">
        <div class=" tw-text-300 tw-font-[500] tw-text-black tw-font-body">+91</div>
        <div class="tw-h-full tw-w-px tw-bg-black tw-ml-1 tw-mr-[9px]"></div>
        <input
          class="tw-flex-1 tw-h-full tw-text-400 tw-text-black tw-border-0 tw-outline-none tw-bg-gray-100 placeholder:tw-font-body"
          i18n-placeholder="@@mobileNumberPlaceholder"
          placeholder="Mobile Number"
          inputmode="numeric"
          autocomplete="tel"
          maxlength="10"
          [value]="resolvedMobileNumber"
          (input)="onMobileInput($event)"
        />
      </div>

      <div class="tw-mt-6">
        <button
          type="button"
          class="tw-w-full tw-rounded-3 tw-py-4 tw-text-500 tw-font-[600] tw-text-white tw-font-lexend"
          [ngClass]="{ 'tw-bg-teal-600': canSendOtp, 'tw-bg-gray-300 tw-text-gray-500 tw-pointer-events-none': !canSendOtp }"
          (click)="onClickSendOtp()"
        >
          <span i18n="@@sendOtp">Send OTP</span>
        </button>
      </div>
    </ng-container>

    <!-- State 2: OTP -->
    <ng-container *ngIf="resolvedMode === 'otp'">
      <div class="tw-text-600 tw-font-[700] tw-leading-tight tw-text-black tw-mb-2" i18n="@@weCanHelpFillAddress">
        We can help fill your address
      </div>
      <div class="tw-text-300 tw-text-gray-800" i18n="@@enterOtpSentToMobile">Enter OTP sent to your mobile no</div>

      <div class="tw-flex tw-items-center tw-gap-[7px] tw-py-[7px] tw-mb-7">
        <div class="tw-text-400 tw-font-[700] tw-text-black">+91 {{ resolvedMobileNumber }}</div>
        <div type="button" class="tw-text-300 tw-font-[700] tw-text-teal-600 tw-flex tw-gap-[3px] tw-justify-between tw-place-items-center tw-w-10 tw-font-body tw-p-0.5" (click)="onClickEdit()">
          <span i18n="@@editNumber">edit</span>
          <img src="/assets/icons/right-chevron-teal-small.svg" alt="edit" class="tw-translate-y-[1px]"/>
        </div>
      </div>

      <div class="tw-flex tw-items-center tw-gap-3">
        <div *ngFor="let _ of otpDigits; let i = index; trackBy: trackByIndex" class="tw-relative tw-w-full tw-max-w-12 tw-aspect-square">
          <input
            #otpInput
            class="tw-w-full tw-max-w-12 tw-aspect-square tw-rounded-3 tw-bg-gray-100 tw-text-center tw-text-600
            tw-p-0 tw-font-[700] tw-text-gray-800 tw-outline-none tw-appearance-none
            tw-ring-1 tw-ring-inset tw-ring-gray-300 focus:tw-ring-teal-600 focus:tw-bg-white placeholder:-tw-translate-y-0.5 focus:placeholder:tw-text-transparent"
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="1"
            placeholder="x"
            (mousedown)="onOtpAttemptFocus($event, i)"
            (touchstart)="onOtpAttemptFocus($event, i)"
            (focus)="onOtpAttemptFocus($event, i)"
            (keydown)="onOtpKeydown($event, i)"
            (input)="onOtpInput($event, i)"
            aria-label="OTP digit"
          />
        </div>
      </div>

      <div class="tw-mt-4 tw-mb-6 tw-text-200 tw-font-body tw-text-gray-800">
        <ng-container *ngIf="timerRemaining > 0">
          <p i18n="@@resendOtpIn">Resend OTP in {{ timerRemaining }}s</p>
        </ng-container>
        <div
          *ngIf="timerRemaining === 0"
          type="button"
          class="tw-text-teal-600 tw-font-[700] tw-max-w-max"
          (click)="onClickResend()"
        >
          <span i18n="@@resendOtp">Resend OTP</span>
        </div>
      </div>

      <div class="">
        <button csButton
          type="button"
          class="tw-w-full tw-rounded-3 tw-py-4 tw-text-600 tw-font-[600] tw-text-white tw-font-lexend"
          [ngClass]="{ 'tw-bg-teal-600': canVerifyOtp, 'tw-bg-gray-300 tw-text-gray-500 tw-pointer-events-none': !canVerifyOtp }"
          [loading]="verifying"
          [disabled]="!canVerifyOtp"
          (click)="onClickVerifyOtp()"
        >
          Continue
        </button>
      </div>
    </ng-container>

    <div class="">
      <img src="/assets/icons/poweredByShipRocket.png" class="tw-w-[150px] tw-mt-2 tw-mx-auto" alt="Powered By Shiprocket" />
    </div>
  </div>
</div>
